import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { IcProfile, IcX } from './Icons';

// The profile fields we nudge students to fill in. Each maps to a friendly
// label shown in the reminder.
const CHECKS = [
  { key: 'profilePicture', label: 'Add a profile photo' },
  { key: 'phone',          label: 'Add your phone number' },
  { key: 'faculty',        label: 'Set your faculty' },
  { key: 'department',     label: 'Set your department' },
  { key: 'dob',            label: 'Add your date of birth' },
];

// A small, dismissible "finish your profile" card pinned bottom-left (above the
// mobile bottom-nav). Shows only for students who still have empty key fields.
export default function ProfileReminder() {
  const navigate = useNavigate();
  const { currentUser, isStudent } = useAuth();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('tt_profile_nudge') === '1');

  if (!isStudent || !currentUser || dismissed) return null;

  const missing = CHECKS.filter(c => {
    const v = currentUser[c.key];
    if (c.key === 'supportContacts') return !(Array.isArray(v) && v.length);
    return v == null || v === '';
  });
  if (!missing.length) return null;

  const close = () => { sessionStorage.setItem('tt_profile_nudge', '1'); setDismissed(true); };

  return (
    <div style={{
      position: 'fixed', left: 16, bottom: 84, zIndex: 160, width: 260, maxWidth: 'calc(100vw - 32px)',
      background: 'var(--white)', border: '1px solid var(--nat-d)', borderRadius: 14,
      boxShadow: '0 8px 28px rgba(0,0,0,0.16)', padding: '14px 16px',
    }}>
      <button onClick={close} aria-label="Dismiss" style={{ position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--txt-l)', padding: 4 }}>
        <IcX size={13} />
      </button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <div style={{ width: 30, height: 30, borderRadius: 9, background: 'var(--org-l)', color: 'var(--org)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <IcProfile size={15} />
        </div>
        <div style={{ fontSize: 13.5, fontWeight: 800, color: 'var(--txt-d)' }}>Finish your profile</div>
      </div>
      <div style={{ fontSize: 11.5, color: 'var(--txt-l)', lineHeight: 1.5, marginBottom: 10 }}>
        {missing.length} {missing.length === 1 ? 'thing' : 'things'} left: {missing.slice(0, 2).map(m => m.label.toLowerCase()).join(', ')}
        {missing.length > 2 ? ` +${missing.length - 2} more` : ''}.
      </div>
      <button className="btn btn-primary btn-sm btn-full" onClick={() => { close(); navigate('/account'); }}>
        Complete it
      </button>
    </div>
  );
}
